/* A plain translucent ink layer, like Dialog; no blur. */
.overlay {
  position: fixed;
  inset: 0;
  z-index: var(--z-dialog);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 12vh var(--space-4) var(--space-4);
  background: var(--scrim);
}

.overlay[data-entering] {
  animation: fade var(--dur) var(--ease);
}

.modal {
  width: 100%;
  max-width: 640px;
  max-height: calc(88vh - var(--space-4));
  overflow: auto;
  border-radius: var(--radius-float);
  background: var(--paper);
  box-shadow: var(--shadow-float);
}

.dialog {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-5);
  outline: none;
}

.close {
  display: none;
  align-self: flex-end;
  align-items: center;
  min-height: var(--touch-target);
  padding: 0 var(--space-2);
  border: 0;
  border-radius: var(--radius-control);
  background: transparent;
  color: var(--ink);
  font: var(--t-body-strong);
  cursor: pointer;
}

.close[data-pressed] {
  background: var(--wash);
}

.close[data-focus-visible] {
  outline: var(--focus-ring);
  outline-offset: -2px;
}

.hint {
  color: var(--graphite);
  font: var(--t-small);
}

/* Phones: a full-screen sheet, so the keyboard and results both fit. */
@media (width < 640px) {
  .overlay {
    align-items: stretch;
    padding: 0;
  }

  .modal {
    max-width: none;
    max-height: none;
    min-height: 100dvh;
    border-radius: 0;
  }

  .dialog {
    padding: var(--space-2) var(--gutter) var(--space-4);
  }

  /* There is no Esc key on a phone: offer a Close button instead. */
  .close {
    display: flex;
  }
}

@keyframes fade {
  from {
    opacity: 0;
  }
}
